import * as React from 'react';

import { Watch } from 'scrollmonitor-react';

import './articleTwoColTextAndImage.scss';
 

class ArticleTwoColTextAndImage extends React.Component {
  render() {
    let theBlock = this.props.block;
    let colOneClass = theBlock.textFirst ? "col-md-4 offset-md-2" : "col-md-6";
    let colTwoClass = theBlock.textFirst ? "col-md-6" : "col-md-4 offset-md-1";
    let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    function BlockImage() {
        return (
            <>
            <figure>
                <div className="is-image">
                    <img src={baseUrl+theBlock.blockImage} alt={theBlock.blockImageAlt}/>
                </div>
                {theBlock.blockImageCaption ? <figcaption>{theBlock.blockImageCaption}</figcaption> : ""}
            </figure>
            </>
        );
    }
    return (
    <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
        <div className="container"> 
            <div className="row">
                <div className="col-12 mb-sm-4">
                    <div className="row">
                        <div className={colOneClass}>
                            {theBlock.textFirst ? <div dangerouslySetInnerHTML={{__html: theBlock.blockHtml}} /> : <BlockImage/>}
                        </div>
                        <div className={colTwoClass}>
                            {theBlock.textFirst ? <BlockImage/> : <div dangerouslySetInnerHTML={{__html: theBlock.blockHtml}} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleTwoColTextAndImage);
